import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Creatable } from 'react-select';

import AuthService from '../../state/auth.service';

class UserSelect extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            options: [],
            selected: props.value || '',
        };

        this.getNewItemLabel = this.getNewItemLabel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
    }

    handleChange(selectedOption) {
        if (selectedOption) {
            this.setState({ selected: selectedOption.value });
            this.props.onSelect(selectedOption.value);
        } else {
            this.setState({ selected: '' });
            this.props.onSelect('');
        }
    }

    getManageLink() {
        const orgId = this.props.organization;
        // only admins or consultants can see this link...
        const user = AuthService.getUser();
        if (user.organization_id === '-1' || user.role === 'Administrator') {
            return (
                <Link to={`/organization/${orgId}/team`}>
                    Manage Organization Team
                </Link>
            );
        }
        return null;
    }

    render() {
        // Fix edge case where the user has written in someone who isn't in
        // the options list
        if (this.state.selected && this.state.selected.length > 0) {
            let found = false;
            this.state.options.forEach(option => {
                if (option.value === this.state.selected) {
                    found = true;
                }
            });
            if (!found) {
                this.state.options.push({
                    label: this.state.selected,
                    value: this.state.selected,
                });
            }
        }

        const manageLink = this.getManageLink();
        return (
            <div className="UserSelect">
                <Creatable
                    name={this.props.name}
                    resetValue=""
                    value={this.state.selected}
                    onChange={this.handleChange}
                    options={this.state.options}
                    promptTextCreator={this.getNewItemLabel}
                />
                {manageLink}
            </div>
        );
    }
}

export default UserSelect;
